import {
  MeasureFormatter,
  MeasureIcon,
} from '@principle-theorem/principle-core/interfaces';
import { ICanBeChartedProperty } from '@principle-theorem/reporting/interfaces';

const measureFormatterMap: { [key in MeasureFormatter]: MeasureIcon } = {
  [MeasureFormatter.Boolean]: MeasureIcon.Checkbox,
  [MeasureFormatter.Currency]: MeasureIcon.Money,
  [MeasureFormatter.Custom]: MeasureIcon.QuestionMark,
  [MeasureFormatter.Day]: MeasureIcon.Calendar,
  [MeasureFormatter.Hours]: MeasureIcon.Schedule,
  [MeasureFormatter.Link]: MeasureIcon.Link,
  [MeasureFormatter.Minutes]: MeasureIcon.Schedule,
  [MeasureFormatter.Month]: MeasureIcon.Calendar,
  [MeasureFormatter.Number]: MeasureIcon.Numbers,
  [MeasureFormatter.Percentage]: MeasureIcon.Percent,
  [MeasureFormatter.Prefix]: MeasureIcon.QuestionMark,
  [MeasureFormatter.Suffix]: MeasureIcon.QuestionMark,
  [MeasureFormatter.Text]: MeasureIcon.Text,
  [MeasureFormatter.Time]: MeasureIcon.Schedule,
  [MeasureFormatter.Timestamp]: MeasureIcon.Calendar,
};

export class ReportBuilderDataPoint {
  static getLabel(
    property?: ICanBeChartedProperty,
    customLabel?: string
  ): string {
    return customLabel ?? property?.metadata.label ?? 'Unknown';
  }

  static getIcon(property?: ICanBeChartedProperty): MeasureIcon {
    if (property?.metadata.icon) {
      return property.metadata.icon;
    }

    return property?.metadata.formatter
      ? measureFormatterMap[property.metadata.formatter]
      : MeasureIcon.QuestionMark;
  }

  static getDescription(property?: ICanBeChartedProperty): string {
    return property?.metadata.summary ?? '';
  }
}
